"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("source-map-support/register");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * The process phase processes the command line input and builds a command
 * pipeline to be executed in the next step
 */


var process = function process(_ref) {
  var compilerService = _ref.compilerService,
      configService = _ref.configService;
  return function (next) {
    return function (args) {
      var context = args.context;
      var name = configService.name;
      var input = context.message.text;
      var source = input.substring(input.indexOf(name) + name.length + 1); // remove bot hail portion from command

      var _compilerService$comp = compilerService.compileWithMetadata(source),
          command = _compilerService$comp.command,
          metadata = _compilerService$comp.metadata;

      next(_objectSpread({}, args, {
        source: source,
        command: command,
        metadata: metadata
      }));
    };
  };
};

var _default = process;
exports.default = _default;